// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__UdZTr","label":"Tags_label__-Ogef","tooltip":"Tags_tooltip__Wqjky"};